// extracted by mini-css-extract-plugin
module.exports = {"columnWrap":"PolicyGroupTemplateManageItemRow__columnWrap","row":"PolicyGroupTemplateManageItemRow__row","space":"PolicyGroupTemplateManageItemRow__space"};